// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import styles from './TabletTab.module.scss';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

interface Props {
  className?: string;
  tabItems: string[];
  defaultTabIndex: number;
  renderContent: (item: { index: number; tab: string }) => React.ReactNode;
  setTabIndex?: (tabIndex: number) => void;
}

export const TabletTab = ({
  className,
  tabItems,
  defaultTabIndex,
  renderContent,
  setTabIndex,
}: Props) => {
  const [activeTabIndex, setActiveTabIndex] = useState(
    defaultTabIndex ? defaultTabIndex : 0
  );

  useEffect(() => {
    if (setTabIndex) {
      setTabIndex(activeTabIndex);
    }
  }, [activeTabIndex]);

  const history = useHistory();

  return (
    <div className={className}>
      <div className={styles.tabMenu}>
        <div className={styles.tabItems}>
          {tabItems.map((it, index) => {
            const active = index === activeTabIndex;

            return (
              <div
                key={it}
                className={
                  `${styles.tabItem} ` +
                  (active ? `${styles.tabItemActive}` : '')
                }
                onClick={() => {
                  setActiveTabIndex(index);
                  history.push(`${window.location.search}#` + index);
                }}
              >
                {it}
              </div>
            );
          })}
        </div>
      </div>
      <div>
        {tabItems.map((tab, index) => {
          if (index !== activeTabIndex) {
            return null;
          }

          return (
            <div key={`tab-content-${index}`}>
              {renderContent({ index, tab })}
            </div>
          );
        })}
      </div>
    </div>
  );
};
